// // npm run build-prod
// export const environment = {
//   production: true,
//   apiKey: "AIzaSyCoFPB7IdcBqlYRQv1Vbrsiuid3ithjBMs",
//   firebase: {
//     authDomain: "goldhubberdev.firebaseapp.com",
//     databaseURL: "https://goldhubberdev.firebaseio.com",
//     projectId: "goldhubberdev",
//     storageBucket: "goldhubberdev.appspot.com",
//     messagingSenderId: "103953800507"
//   },
//   stripeKey: "pk_test_EX0Xoo3stGhOJS4UKyQHurhY",
//   connectStripe: "ca_DDoCYpdgb0zAHWjwo1oF9ZlQ4qVXKrPw",

//   // stripeKey: "pk_live_WybIGRxXVCtikfht1xltl1uk",
//   // connectStripe: "ca_DDoCQaGr8pvCscKPcOvug1baSUCgvL9a",
//   // firebase: {
//   //   apiKey: "AIzaSyBYLbM2piUY6tNZSeJkxirZi0Q2Nj7Hl4o",
//   //   authDomain: "golfhubberprod.firebaseapp.com",
//   //   databaseURL: "https://golfhubberprod.firebaseio.com",
//   //   projectId: "golfhubberprod",
//   //   storageBucket: "golfhubberprod.appspot.com",
//   //   messagingSenderId: "674141673617"
//   // },
//   version: "4.9.0"
// };
export const environment = {
  production: false,
  version: require('../../package.json').version,

  // firebase: {
  //   apiKey: "AIzaSyCoFPB7IdcBqlYRQv1Vbrsiuid3ithjBMs",
  //   authDomain: "goldhubberdev.firebaseapp.com",
  //   databaseURL: "https://goldhubberdev.firebaseio.com",
  //   storageBucket: "gs://goldhubberdev.appspot.com",
  //   messagingSenderId: "103953800507"
  // },
  // stripeKey: "pk_test_8xyzJwV5BJXSrs2hHK6bnmVb",
  // connectStripe: "ca_DDoCYpdgb0zAHWjwo1oF9ZlQ4qVXKrPw",
  // committeeUrl: "http://applanche.com/golfhubber-club-committee/#/login"

  firebase: {
    apiKey: "AIzaSyBYLbM2piUY6tNZSeJkxirZi0Q2Nj7Hl4o",
    authDomain: "golfhubberprod.firebaseapp.com",
    databaseURL: "https://golfhubberprod.firebaseio.com",
    storageBucket: "gs://golfhubberprod.appspot.com",
    messagingSenderId: "103953800507"
  },
  stripeKey: "pk_live_WybIGRxXVCtikfht1xltl1uk",
  connectStripe: "ca_DDoCQaGr8pvCscKPcOvug1baSUCgvL9a",
  committeeUrl: "https://golfhubber.com/committee/#/login",
};



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/environments/environment.ts